import { SegmentFactory } from "./SegmentFactory";

export const createSegment = (href, router) => {
  const segment = SegmentFactory.createInstance(href, router);
  return segment;
};
